import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import Navbar from "@/components/app/Navbar";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Bell, CheckCheck } from "lucide-react";

export default function Notifications() {
  const [items, setItems] = useState([]);
  const load = async () => {
    const r = await api.get("/notifications");
    setItems(r.data.notifications);
  };
  useEffect(() => { load(); }, []);
  const markAll = async () => {
    await api.post("/notifications/read");
    await load();
    toast.success("Marked as read");
  };

  return (
    <div className="min-h-screen">
      <Navbar />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex items-center justify-between mb-6">
          <h1 className="font-display text-3xl md:text-4xl font-medium">Notifications</h1>
          <Button variant="ghost" onClick={markAll} data-testid="notif-mark-all"><CheckCheck className="w-4 h-4 mr-2" /> Mark all read</Button>
        </div>
        {items.length === 0 && <div className="text-center py-16 text-stone-500 border border-dashed border-stone-300 rounded-2xl">You're all caught up.</div>}
        <div className="space-y-2">
          {items.map((n) => (
            <div key={n.id} data-testid={`notif-${n.id}`} className={`p-4 rounded-2xl border ${n.is_read ? "bg-white border-stone-200" : "bg-[#2A4B3C]/[0.03] border-[#2A4B3C]/20"}`}>
              <div className="flex items-start gap-3">
                <Bell className="w-4 h-4 text-brand mt-0.5" />
                <div className="flex-1">
                  <div className="text-sm font-medium">{n.title}</div>
                  <div className="text-sm text-stone-600">{n.body}</div>
                  <div className="text-xs text-stone-400 mt-1">{new Date(n.created_at).toLocaleString()}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
